
import * as projectTypes from './actions';
import { createReducer, on, Action } from '@ngrx/store';
import { initializeProjectsState, State } from './state';


export const initialState = initializeProjectsState();

const reducer = createReducer(
  initialState,
  on(projectTypes.GetProjectsAction, state => ({...state, isLoading: true, filters: ''})),
  on(projectTypes.ProjectsLoadedAction, (state: State, { payload }) => {
    return {
      ...state,
      projects: payload,
      filteredProjects: payload,
      isLoading : false
    };
  }),
  on(projectTypes.GetFilteredProjectsAction, (state, { payload }) => ({...state, isLoading: true, filters: payload})),
  on(projectTypes.FilteredProjectsLoadedAction, (state: State, { payload }) => {
    return {
      ...state,
      filteredProjects: payload,
      isLoading : false
    };
  }),
  on(projectTypes.BeginCreateProjectAction, state => state),
  on(projectTypes.SuccessCreateProjectAction, (state: State, { payload }) => {
    return {
      ...state,
      projects: [payload, ...state.projects],
      filteredProjects: [payload, ...state.filteredProjects]
    };
  }),
  on(projectTypes.BeginDeleteProjectAction, state => state),
  on(projectTypes.SuccessDeleteProjectAction, (state: State, { payload }) => {
    return {
      ...state,
      projects: state.projects.filter((project) => project._id !== payload),
      filteredProjects: state.filteredProjects.filter((project) => project._id !== payload),
    };
  }),
  on(projectTypes.BeginCloneProjectAction, state => state),
  on(projectTypes.SuccessCloneProjectAction, (state: State, { payload }) => {
    return {
      ...state,
      projects: [payload, ...state.projects],
      filteredProjects: [payload, ...state.projects]
    };
  }),
  on(projectTypes.BeginGetSelectedProjectAction, state => ({...state, isSelectedProjectLoading : true})),
  on(projectTypes.SuccessGetSelectedProjectAction, (state: State, { payload }) => {
    return {
      ...state,
      selectedProject: payload,
      isSelectedProjectLoading : false
    };
  }),
  on(projectTypes.BeginUpdateProjectAction, state => state),
  on(projectTypes.SuccessUpdateProjectAction, (state: State, { payload }) => {
    return {
      ...state,
      projects: state.projects.map((project) => project._id !== payload._id ? project : payload),
      selectedProject: payload
    };
  }),
  on(projectTypes.BeginUploadImageAction, state => state),
  on(projectTypes.SuccessUploadImageAction, (state: State, { payload }) => {
    return {
      ...state,
      projects: state.projects.map((project) => project._id !== payload._id ? project : payload),
      selectedProject: payload
    };
  }),
  on(projectTypes.BeginUpdateLastUsedProjectAction, state => state),
  on(projectTypes.SuccessUpdateLastUsedProjectAction, (state: State, { payload }) => {
    return {
      ...state,
      projects: [...state.projects.map(e => e._id === payload._id ? payload : e), ]
    };
  }),
);

export function ProjectsReducer(state: State | undefined, action: Action) {
  return reducer(state, action);
}
